import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { RootState } from '../types';

// For more info, see: https://react-redux.js.org/using-react-redux/static-typing
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
